/*
 *  Javascript Calendar v1.0.0
 *
 *  Author : Srinivas Nagorkar Year : 2015
 *
 *  call calendar.render("#reference-id-here",endDate);
 *  i.e : call calendar.render("#calendar",undefined);
 */
var calendar = {
  // setting up the stage for pre requisite variables and amounts
  month_names: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  // lets check the currenct year as, is the leap year ?
  isLeapYear: function(year) {
    if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
      var d = new Date()
      d.setYear(year)
      d.setMonth(1)
      d.setDate(29)
      this.month_days[1] = 29
    }
  },
  month_days: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  // Get today's date - year, month, day and date
  today: new Date(),
  endDate: '',
  currMonth: new Date(),
  dateFormatForInput: function(date) {
    // var date = date
    var dateOnly = ('0' + date.getDate()).slice(-2)
    var monthOnly = ('0' + (date.getMonth() + 1)).slice(-2)
    var yearOnly = date.getUTCFullYear()
    this.isLeapYear(yearOnly)
    return dateOnly + '/' + monthOnly + '/' + yearOnly
  },
  preRender: function(id) {
    var _this = this
    var tody = new Date()
    var OneYr = new Date()
    OneYr.setYear(tody.getFullYear() + 1)
    _this.endDate = new Date(OneYr)
    // var id = id
    var inputEle = document.getElementById(id)
    var dateByRef = inputEle.value != '' ? inputEle.value : this.today
    inputEle.value == '' ? (inputEle.value = this.dateFormatForInput(dateByRef)) : false
    inputEle.onclick = function(e) {
      _this.calInpClicked(inputEle.id)
    }
    // else if(inputEle.attachEvent)inputEle.attachEvent('click', this.calInpClicked(id));
  },
  calInpClicked: function(str) {
    this.createCalendar(str)
  },
  render: function(str, endDate, selectCallback) {
    this.preRender(str)
    this.selectCallback = selectCallback
    if (endDate != undefined) {
      this.endDate = endDate
    }
  },
  createCalendar: function(str, refDate) {
    // var clientWidth = document.documentElement.clientWidth
    var twoCalendars = false
    // twoCalendars = clientWidth > 640
    this.destroyCalendar(str)
    var inputItem = document.getElementById(str)
    var inputVal = inputItem.value
    if (refDate != null || refDate != undefined) {
      var date = refDate
    } else if (inputVal != '') {
      var sD = inputVal.split('/')
      var date = new Date(sD[2], sD[1] - 1, sD[0])
    } else {
      var date = new Date()
    }
    // var defDate = date.getDate()
    var defMonth = this.month_names[date.getUTCMonth()]
    var defYear = date.getFullYear()
    var setStartDate = new Date('01 ' + defMonth + ' ' + defYear)
    var lastDay = new Date(setStartDate.getFullYear(), setStartDate.getMonth() + 1, 0)
    this.currMonth = date
    var template = "<div class='custom-calendar'><div class='calendarHeader'>Select Date<span id='closeCalendarIco' class='closeCalendarIco'>&times;</span></div>" + "<div class='navi'><div id='prevBtn' class='prevBtn'><</div><div id='nextBtn' class='nextBtn'>></div></div>"
    var templateTwo = ''
    var templateTwo = "<div class='firstCalendar'>" + "<div class='monthDesc'><div id='monthYearPane' class='monthYearPane'>" + this.month_names[setStartDate.getMonth()] + ' ' + setStartDate.getFullYear() + '</div></div>' + "<table cellspacing='0' cellpadding='0'><tr><th>Sun</th><th>Mon</th><th>Tue</th><th>Wed</th><th>Thu</th><th>Fri</th><th>Sat</th></tr>"
    var once = false
    for (var i = 0; i <= 5; i++) {
      templateTwo = templateTwo + '<tr>'
      for (var j = 0; j <= 6; j++) {
        var disabled = ''
        disabled = this.today.setHours(0, 0, 0, 0) > setStartDate ? 'disabledCal' : 'selectable'
        var weekend = j == 0 || j == 6 ? 'weekend' : ''
        if (setStartDate.getDay() == j) {
          if (once == false) {
            var inputValIn = inputVal.split('/')
            var tdm = setStartDate.toDateString() == new Date(inputValIn[2], inputValIn[1] - 1, inputValIn[0]).toDateString() ? "<td class='selected " + disabled + ' ' + weekend + "'>" : "<td class='" + disabled + ' ' + weekend + "'>"
            templateTwo = templateTwo + tdm + setStartDate.getDate() + '</td>'
          } else {
            templateTwo = templateTwo + "<td class='nocursor'>&nbsp;</td>"
          }
          if (lastDay.toLocaleString() == setStartDate.toLocaleString()) {
            once = true
          }
          if (setStartDate < lastDay) setStartDate = new Date(setStartDate.setDate(setStartDate.getDate() + 1))
        } else {
          templateTwo = templateTwo + "<td class='nocursor'>&nbsp;</td>"
        }
      }
      templateTwo = templateTwo + '</tr>'
    }
    templateTwo = templateTwo + '</table></div>'
    var templateMonthTwo = ''
    if (twoCalendars) {
      var once = false
      if (setStartDate.getMonth() == 11) {
        var nextMonth = new Date(setStartDate.getFullYear() + 1, 0, 1)
      } else {
        var nextMonth = new Date(setStartDate.getFullYear(), setStartDate.getMonth() + 1, 1)
      }
      setStartDate = nextMonth
      var lastDay = new Date(setStartDate.getFullYear(), setStartDate.getMonth() + 1, 0)
      templateMonthTwo = "<div class='secondMonth'>" + "<div class='monthDesc'><div id='monthYearPane' class='monthYearPane'>" + this.month_names[setStartDate.getMonth()] + ' ' + setStartDate.getFullYear() + '</div></div>' + "<table cellspacing='0' cellpadding='0'><tr><th>Sun</th><th>Mon</th><th>Tue</th><th>Wed</th><th>Thu</th><th>Fri</th><th>Sat</th></tr>"
      for (let i = 0; i <= 5; i++) {
        templateMonthTwo = templateMonthTwo + '<tr>'
        for (let j = 0; j <= 6; j++) {
          var weekend = j == 0 || j == 6 ? 'weekend' : ''
          var disabled = ''
          disabled = this.today.setHours(0, 0, 0, 0) > setStartDate ? 'disabledCal' : 'selectable'
          if (setStartDate.getDay() == j) {
            if (once == false) {
              var inputValIn = inputVal.split('/')
              var tdm = setStartDate.toDateString() == new Date(inputValIn[2], inputValIn[1] - 1, inputValIn[0]).toDateString() ? "<td class='selected " + disabled + ' ' + weekend + "'>" : "<td class='" + disabled + ' ' + weekend + "'>"
              templateMonthTwo = templateMonthTwo + tdm + setStartDate.getDate() + '</td>'
            } else {
              templateMonthTwo = templateMonthTwo + "<td class='nocursor'>&nbsp;</td>"
            }
            if (lastDay.toLocaleString() == setStartDate.toLocaleString()) {
              once = true
            }
            if (setStartDate < lastDay) setStartDate = new Date(setStartDate.setDate(setStartDate.getDate() + 1))
          } else {
            templateMonthTwo = templateMonthTwo + "<td class='nocursor'>&nbsp;</td>"
          }
        }
        templateMonthTwo = templateMonthTwo + '</tr>'
      }
      templateMonthTwo = templateMonthTwo + '</table></div>'
    }
    templateTwo = templateTwo + templateMonthTwo
    templateTwo = templateTwo + '</div>'
    template = template + templateTwo
    var temp = document.createElement('div')
    temp.id = str + 'Calendar'
    temp.innerHTML = template
    this.setCalWidth(temp)
    inputItem.parentElement.appendChild(temp)
    this.initCalEvents(str)
    if (document.getElementById('monthYearPane').innerHTML == this.month_names[this.endDate.getMonth()] + ' ' + this.endDate.getFullYear()) {
      document.getElementById('nextBtn').style.display = 'none'
    } else {
      document.getElementById('nextBtn').style.display = 'block'
    }
  },
  setCalWidth: function(node) {
    var calId = node.id
    var inpId = calId.substring(0, calId.length - 8)
    var clientWidth = document.documentElement.clientWidth
    var ele = document.getElementById(inpId)
    node.className = ''
    if (clientWidth <= 320) {
      node.className = 'mobileCalendar'
    } else if (clientWidth <= 640) {
      node.className = 'tabletCalendar'
    } else {
      node.className = 'desktopCalendar'
    }
    node.style.top = ele.offsetHeight + ele.offsetTop + 'px'
    node.style.left = ele.offsetLeft + 'px'
    // node.style.width = ele.offsetWidth+"px";
    this.placeCalendar(inpId, node)
  },
  placeCalendar: function(id, calendarEle) {
    var id = id
    var inputBoundaries = document.getElementById(id).getBoundingClientRect()
    var topIpn = inputBoundaries.y || inputBoundaries.top
    var leftIpn = inputBoundaries.x || inputBoundaries.left
    var heightIpn = document.getElementById(id).clientHeight
    // var calendar = document.getElementById(id+"Calendar");
    var clientWidth = document.documentElement.clientWidth
    if (clientWidth >= 640) {
      calendarEle.style.top = topIpn + heightIpn + 4
      calendarEle.style.left = leftIpn
      calendarEle.style.position = 'absolute'
    }
  },
  removeElement: function(element) {
    element && element.parentNode && element.parentNode.removeChild(element)
  },
  initCalEvents: function(str) {
    var id = str
    var _this = this
    document.getElementById('prevBtn').onclick = function(e) {
      var prevMonth = new Date(_this.currMonth.setMonth(_this.currMonth.getMonth() - 1))
      _this.createCalendar(id, prevMonth)
    }
    document.getElementById('nextBtn').onclick = function(e) {
      var nextMonth = new Date(_this.currMonth.setMonth(_this.currMonth.getMonth() + 1))
      _this.createCalendar(id, nextMonth)
    }
    document.getElementById('closeCalendarIco').onclick = function(e) {
      _this.destroyCalendar(str)
    }
    window.onresize = function() {
      if (document.getElementById(str + 'Calendar') != null || document.getElementById(str + 'Calendar') != undefined) {
        _this.setCalWidth(document.getElementById(str + 'Calendar'))
      }
    }
    var tds = document.getElementById(str + 'Calendar').getElementsByTagName('td')
    function hasClass(element, cls) {
      return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1
    }
    for (let i = 0; i < tds.length; i++) {
      tds[i].onclick = function() {
        if (this.innerHTML == '&nbsp;' || hasClass(this, 'disabledCal')) {
          return
        }
        if (this.innerHTML != '' || this.innerHTML != '&nbsp;') {
          var string = this.parentElement.parentElement.parentElement.parentElement.firstChild.firstChild.innerHTML
          var date = ('0' + parseInt(this.innerHTML)).slice(-2)
          var month = ('0' + (_this.month_names.indexOf(string.split(' ')[0]) + 1)).slice(-2)
          var year = string.split(' ')[1]
          var selectedDate = date + '/' + month + '/' + year
          document.getElementById(str).value = selectedDate
          if (_this.selectCallback) {
            _this.selectCallback(selectedDate)
          }
          _this.destroyCalendar(str)
        }
      }
    }
  },
  destroyCalendar: function(str) {
    if (document.getElementById(str + 'Calendar') != null) {
      this.removeElement(document.getElementById(str + 'Calendar'))
    }
  }
}

export default { calendar }



// WEBPACK FOOTER //
// ./src/common/calendar.js